<template>
  <div class="gseaHallmark">
    <a-row>
      <a-col :span="24" style="padding: 0px 10px 10px 10px">
        <a-alert
          message="Systematic Identification of genomic instability"
          type="info"
          show-icon
        >
          <div slot="description" style="text-align: justify">
            In order to systematically identify the drivers of genomic
            instability (GI), we conducted inferCNV analysis on the chromosomal
            variations induced by each gene perturbation, concurrently sampling
            an equivalent number of non-targeting cells for comparison. By
            quantifying the scores of the copy number variation (CNV) results,
            we obtained a set of factors that led to drastic changes in
            single-cell DNA copy numbers post perturbation.
          </div>
        </a-alert>
      </a-col>
      <a-col :span="24">
        <!-- <a-tabs default-active-key="1"> -->
        <!-- <a-tab-pane key="1">
            <span slot="tab">
              <a-icon type="bar-chart" />
              Enrichment analysis
            </span>
            <a-row>
              <a-col :span="12" style="padding-right: 10px">
                <img
                  src="http://research.gzsys.org.cn/perturbdb/data/oncoPheno/CIN/CIN.png"
                  alt=""
                  width="100%"
                />
              </a-col>
              <a-col :span="12" style="padding-left: 10px">
                <cinpathway />
              </a-col>
            </a-row>
          </a-tab-pane> -->
        <!-- <a-tab-pane key="2">
            <span slot="tab">
              <a-icon type="menu-unfold" />
              Gene lists
            </span> -->
        <vxe-toolbar>
          <template #buttons>
            <vxe-input
              v-model="filterName_detable"
              type="search"
              placeholder="Input a key word"
              @keyup="searchEvent_detable"
            ></vxe-input>
            <vxe-button @click="exportDataEvent"
              ><a-icon type="cloud-download" /> Download</vxe-button
            >
          </template>
        </vxe-toolbar>
        <vxe-table
          border
          show-overflow
          row-id="id"
          size="small"
          ref="xTable"
          :data="tableData_detable"
          class="my-sort"
          align="center"
          header-align="center"
          :row-config="{ height: 35, isCurrent: true, isHover: true }"
          :column-config="{ isHover: true }"
          :sort-config="{
            showIcon: false,
            trigger: all,
          }"
          @header-cell-click="headerCellClickEvent"
        >
          <!-- <vxe-column type="expand" width="40">
              <template #content="{ row }">
                <object
                  :data="'http://research.gzsys.org.cn/perturbdb/' + row.view"
                  width="100%"
                  height="500"
                ></object>
              </template>
            </vxe-column> -->
          <vxe-column
            field="genename"
            title="Gene name"
            type="html"
            :titlePrefix="{
              icon: 'vxe-icon-question-circle-fill',
              color: 'red',
              useHTML: true,
              message: 'Perturbed gene',
            }"
          >
            <template #default="{ row }">
              <a
                @click="goDataset(row.datasetID, row.genename)"
                style="color: blue; font-weight: bolder"
              >
                {{ row.genename }}</a
              >
            </template>
          </vxe-column>
          <vxe-column
            field="datasetID"
            title="Dataset ID"
            type="html"
          ></vxe-column>
          <vxe-column
            field="medianC"
            title="Median score of NT cells"
            type="html"
            sortable
          >
            <template #header="{ column }">
              <span>{{ column.title }}</span>
              <span class="custom-sort" :class="{ 'is-order': column.order }">
                <i
                  :class="[
                    column.order
                      ? `vxe-icon-sort-numeric-${column.order}`
                      : 'vxe-icon-sort',
                  ]"
                ></i>
              </span>
            </template>
          </vxe-column>
          <vxe-column
            field="medianT"
            title="Median score of perturbed cells"
            type="html"
            sortable
          >
            <template #header="{ column }">
              <span>{{ column.title }}</span>
              <span class="custom-sort" :class="{ 'is-order': column.order }">
                <i
                  :class="[
                    column.order
                      ? `vxe-icon-sort-numeric-${column.order}`
                      : 'vxe-icon-sort',
                  ]"
                ></i>
              </span>
            </template>
          </vxe-column>
          <vxe-column
            field="counts"
            title="Dataset counts"
            type="html"
            sortable
          >
            <template #header="{ column }">
              <span>{{ column.title }}</span>
              <span class="custom-sort" :class="{ 'is-order': column.order }">
                <i
                  :class="[
                    column.order
                      ? `vxe-icon-sort-numeric-${column.order}`
                      : 'vxe-icon-sort',
                  ]"
                ></i>
              </span>
            </template>
          </vxe-column>
          <vxe-column field="boxplot" title="Boxplot" type="html">
            <template #default="{ row }">
              <div @click="showPDF(row.boxplot)">
                <a-button type="primary" size="small">PDF</a-button>
              </div>
            </template>
          </vxe-column>
          <vxe-column field="infercnv" title="InferCNV" type="html">
            <template #default="{ row }">
              <div @click="showPDF(row.infercnv)">
                <a-button type="primary" size="small">PDF</a-button>
              </div>
            </template>
          </vxe-column>

          <template #empty>
            <span style="color: grey"> No more data! </span>
          </template>
        </vxe-table>

        <vxe-pager
          background
          size="small"
          :loading="loading_detable"
          :current-page="tablePage_detable.currentPage"
          :page-size="tablePage_detable.pageSize"
          :total="tablePage_detable.totalResult"
          :page-sizes="[20, 50]"
          :layouts="[
            'PrevPage',
            'JumpNumber',
            'NextPage',
            // 'FullJump',
            'Sizes',
            'Total',
          ]"
          @page-change="handlePageChange_table"
        >
        </vxe-pager>
        <!-- </a-tab-pane>
        </a-tabs> -->
      </a-col>
    </a-row>
    <a-modal
      :visible="this.modal"
      :maskClosable="false"
      :keyboard="false"
      :closable="false"
      style="margin-top: 300px"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div slot="title">Result of inferCNV</div>
      <div slot="cancelText"><a-icon type="cloud-download" /> Download</div>
      <pdf v-if="url && url.endsWith('.pdf')" :src="this.url" />
      <img v-else :src="this.url" width="100%" />
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import XEUtils from "xe-utils";
// import downloadexcel from "vue-json-excel";
import pdf from "vue-pdf";
// import cinpathway from "./cin_patwahy.vue";

export default {
  props: ["value"],
  components: {
    pdf,
    // cinpathway,
  },
  data() {
    return {
      webiste: "http://research.gzsys.org.cn/perturbdb",
      // 弹窗
      modal: false,
      url: "",
      methods: "",
      //加载
      spinning: false,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
      },
    };
  },
  created() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/oncoPheno/searchCIN.php")
      .then((response) => {
        // this.getdata_detable = response.data;
        // 假设 response.data 是包含基因信息的数组
        let geneCounts = {};

        // 统计基因出现的次数
        response.data.forEach((item) => {
          // 假设基因信息存储在 item.gene 中
          let gene = item.genename;
          geneCounts[gene] = (geneCounts[gene] || 0) + 1;
        });

        // 复制原始数据并添加 counts 列
        let newData = response.data.map((item) => ({
          ...item,
          counts: geneCounts[item.genename],
        }));

        // 现在 newData 中每个对象都有 counts 属性表示基因出现的次数

        // 现在 response.data 中每个对象都有 counts 属性表示基因出现的次数
        this.getdata_detable = newData;
        this.findList_detable(this.getdata_detable);
        console.log(newData);
        this.spinning = false;
      });
  },
  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        this.tcgaLoading = true;
        if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    // 基因跳转
    goDataset(value, value2) {
      let href =
        this.webiste +
        "/#/perturbedgenes?datasetId=" +
        value +
        "&gene=" +
        value2;
      window.open(href, "_blank");
    },
    showPDF(value1) {
      this.modal = true;
      this.url = "http://research.gzsys.org.cn/perturbdb/" + value1;
    },
    changeData(value) {
      this.marker = value;
      this.getdata_detable = this.gsea[value];
      this.findList_detable(this.getdata_detable);
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: "PerturbDB_CIN",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename:
            "PerturbDB_CIN" + "-" + this.filterName_detable + "_related",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    handleOk() {
      this.modal = false;
    },
    handleCancel() {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");
      link.style.display = "none";

      // 设置文件的下载链接

      link.href = this.url;

      link.setAttribute(
        "download",
        this.methods + "_" + this.url.split("/").pop()
      );

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1;
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName != "" || filterName != " ") {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["genename", "rtype", "datasetID"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>

<style>
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
